import { useCallback, useEffect, useState } from 'react'
import { BooksitoutServer } from '../../config/BooksitoutServer'
import AdminBookAuthorResponse from './AdminBookAuthorResponse'

const useAdminBookAuthor = (urlName: string | null) => {
	const [data, setData] = useState<AdminBookAuthorResponse | null>(null)
	const [isLoading, setIsLoading] = useState(true)
	const [isError, setIsError] = useState(false)

	const fetch = useCallback((silent = false) => {
		if (urlName == null) return

		if (!silent) setIsLoading(true)
		BooksitoutServer
			.get(`/v1/admin/book-author/${urlName}`)
			.then(res => setData(res.data))
			.catch(() => setIsError(true))
			.finally(() => { if (!silent) setIsLoading(false) })
	}, [urlName])

	useEffect(() => { fetch() }, [fetch])

	return [data, isLoading, isError, fetch] as const
}

export default useAdminBookAuthor
